<template>
  <gs1-alert alertClass="warning" iconClass="fa fa-exclamation-triangle color-orange">
    <p>{{ $t('title') }}</p>
    <ul style="margin-top: 10px;">
      <li v-for="id in ids" :key="id">{{ id }}</li>
    </ul>
    <i18n path="message" tag="p" class="small">
      <router-link :to="{ name: 'Bulk' }">{{ $t('redo') }}</router-link>
    </i18n>
  </gs1-alert>
</template>

<script>
import Gs1Alert from './Gs1Alert'
export default {
  components: {
    Gs1Alert
  },
  props: ['ids'],
  i18n: {
    messages: {
      de: {
        title: 'Einige Suchanfragen sind fehlerhaft.',
        message: 'Fortfahren oder {0}.',
        redo: 'eine neue Suche starten'
      },
      en: {
        title: 'Some of your search terms had errors.',
        message: 'You can continue or {0}.',
        redo: 'redo the search'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/Gs1AlertSearchTermErrors.vue